import { useEffect } from 'react'
import {
  TableRow,
  TableCell,
  Tooltip, 
} from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import WarningAmber from "@mui/icons-material/WarningAmber";

const RunSteps = ({ steps, activeStep, setActiveStep, handleSeek }) => {
  useEffect(() => {
    if (steps[1]?.id) {
      setActiveStep(steps[1].id)
      handleSeek(steps[1]?.breakpoint)
    } else {
      setActiveStep(steps[0]?.id)
    }
  // eslint-disable-next-line
  }, [steps])

  const handleItemClick = (item) => {
    if (item.breakpoint !== undefined) {
      handleSeek(item.breakpoint)
    }
    setActiveStep(item.id)
  }
    const shownValue = (item) => {
        if (item.label && item.label.toLowerCase().includes("click")) {
            return "";
        }
        if (item.label && item.label.toLowerCase().includes("upload")) {
            if (item.value === "<valid>") {
                return "Valid file";
            }
            if (item.value === "<invalid>") {
                return "Invalid file";
            }
        }
        return item.value;
  }

  const renderRows = (items, indexOffset = { current: 1 }) => {
      return items.flatMap((item) => {
      const index = indexOffset.current++
    return (
        <Tooltip
            key={item.id}
            title="Error occurred on this step"
            enterDelay={0}
            enterNextDelay={0}
            disableHoverListener={item?.result !== "FAILED"}
            arrow
        >
            <TableRow
                className="testRunResultsTableBodyRow"
                onClick={() => handleItemClick(item)}
                sx={{
                    backgroundColor:
                        activeStep === item.id
                            ? "rgba(69, 116, 210, 0.1)"
                            : "transparent",
                }}
            >
                <TableCell className="testRunResultsTableBodyCell stepIndexCell">
                    {index}
                </TableCell>
                <TableCell className="testRunResultsTableBodyCell stepNameCell">
                    {item.label || "empty label"}
                </TableCell>
                <TableCell className="testRunResultsTableBodyCell stepDataCell">
                    {shownValue(item)}
                </TableCell>
                <TableCell className="testRunResultsTableBodyCell stepResultCell">
                    {item.result === "SUCCESS" ? (
                        <CheckCircleIcon color="success" />
                    ) : (
                        <WarningAmber color="warning" />
                    )}
                </TableCell>
            </TableRow>
        </Tooltip>
    );
    })
  }

  return <>{renderRows(steps)}</>
}

export default RunSteps